/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import React, { useContext } from 'react';
import DiviFieldCard from '../../../customs/DiviFieldCard/DiviFieldCard';
import { NodeType } from '../../../../backendModels/report.model';
import { getSituationsAndSymptomsTuplesFor, SituationsAndSymptomsKeys } from '../../../../models/situationsAndSymptoms';
import { ReportsAPIContext } from '../../../../provider/ReportsAPIProvider';
import { defaultRecords } from '../../../../DefaultRecords';
import _ from 'lodash';
import { CardId } from '../../../../models/diviCard';
import RadioList from '../../../customs/radioList/RadioList';

export interface SituationAndSymptomsProps {
  readonly nodeType: NodeType;
  readonly situationAndSymptomsKeys: SituationsAndSymptomsKeys[];
  readonly cardId: CardId;
}

export default function SituationAndSymptoms({
  nodeType,
  situationAndSymptomsKeys,
  cardId,
}: SituationAndSymptomsProps) {
  const items = getSituationsAndSymptomsTuplesFor(situationAndSymptomsKeys);
  const reportAPI = useContext(ReportsAPIContext);
  const record = reportAPI.findRecordOrDefault(defaultRecords.situationAndSymptoms.type, nodeType);
  const symptoms = (record.situationAndSymptoms ?? []) as SituationsAndSymptomsKeys[];

  const updateRecord = (value: string | null) => {
    reportAPI.adaptRecord(defaultRecords.situationAndSymptoms.type, nodeType, (draft, deleteRecord) => {
      const symptomsWithoutRadio = _.difference(symptoms, situationAndSymptomsKeys);
      if (value == null && symptomsWithoutRadio.length === 0 && !draft.note) {
        deleteRecord();
      } else {
        return {
          ...draft,
          situationAndSymptoms: [...symptomsWithoutRadio, ...(value === null ? [] : [value])],
        };
      }
    });
  };

  return (
    <DiviFieldCard cardType={cardId}>
      <div className='symptoms-list'>
        <RadioList
          items={items}
          name={`${cardId}-group`}
          value={_.intersection(symptoms, situationAndSymptomsKeys)[0] ?? null}
          onChange={updateRecord}
        />
      </div>
    </DiviFieldCard>
  );
}
